/**
 * 历史名字池 - localStorage 持久化
 */

const KEY = "nameHistory.v2";
const MAX_SIZE = 200;

function safeRead(): string[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    if (!Array.isArray(arr)) return [];
    return arr.filter((x): x is string => typeof x === "string").slice(0, MAX_SIZE);
  } catch {
    return [];
  }
}

function safeWrite(names: string[]): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(names.slice(0, MAX_SIZE)));
  } catch {
    /* ignore */
  }
}

export function getHistory(): string[] {
  return safeRead();
}

export function addName(name: string): void {
  const trimmed = name.trim();
  if (!trimmed) return;
  const list = safeRead();
  if (list.includes(trimmed)) {
    // 把刚用的移到队首
    const filtered = list.filter((n) => n !== trimmed);
    filtered.unshift(trimmed);
    safeWrite(filtered);
    return;
  }
  list.unshift(trimmed);
  safeWrite(list);
}

export function getNamePool(seedPool: string[]): string[] {
  const history = safeRead();
  if (history.length >= 30) return history;
  // 补 seed
  const merged = [...history];
  for (const n of seedPool) {
    if (merged.length >= 30) break;
    if (!merged.includes(n)) merged.push(n);
  }
  return merged;
}
